import {
  ReportHighLow,
  ReportStandardVacation,
  ReportFamilyData,
  ReportHistorical,
  ReportStandardEmployees,
  ReportEmployeeBankAccounts,
  ReportPayrollStandard,
  ReportCustomizedPayroll,
  ReportVacationBalance,
  ReportIncidents,
  ReportComparative,
  ReportNet,
  ReportConceptDetails,
  ReportAllowancesDeductions,
  ReportLafise,
  ReportAccountingProvisions,
  ReportAccountingEntry,
  ReportSalaryHistoric,
  ReportAsoveritas,
  ReportG2N,
  ReportPayRegister,
  ReportMagistery,
  ReportLCI,
  ReportPagus,
  ReportConceptBases,
  ReportBonus,
  ReportVacationMSC,
  ReportGTN,
  ReportEmbargoesLoans,
  ReportVacationsAccrual,
  ReportEmbargoes,
  ReportIncomeTax,
  ReportVariability,
  ReportSummaryPayments,
  ReportComparativeConcept,
  ReportHeadcountRegional,
  ReportSummaryConcepts,
  ReportISN,
  ReportInfonacotCertification,
  ReportSUAWorkers,
  ReportSUAAffiliations,
  ReportSUALicenses,
  ReportSUALoans,
  ReportSUAMovements,
  ReportInfonacotIdentification,
  ReportGoSocket4,
  ReportIDSEJoining,
  ReportIDSELeaving,
  ReportIDSESalaries,
  ReportInfonacotCredit,
  ReportRentTemplate,
  ParameterStampedPayroll
} from './types'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
export * from './types'
export * from './bi-custom'
export { getEmployerRecords } from './customized/pay-employees'

import dayjs from 'dayjs'
import * as XLSX from "xlsx"
import { useUserStore } from '@/store/user'
import { usePayrollStore } from '@/store/payroll-data'

const http = new HttpService()

/* convertir array a string */
export async function convertArrayToString(array: any) {
  return array.length === 0 ? '' : "'" + array.join("','") + "'"
}

/* Consultas generales */
export async function getPayroll(userId: string) {
  const payrolls = await getData<any>({
    tables: ['pg_user_enabled_payrolls'],
    join: [
      'INNER JOIN payrolls ON user_enabled_payrolls.payroll_id = payrolls.id'
    ],
    fields: ['payrolls.code'],
    where: [`user_enabled_payrolls.user_id = '${userId}'`]
  })
  const data = await getData<any>({
    tables: ['pg_payrolls'],
    fields: [
      'payrolls.id',
      "CONCAT(payrolls.code,'-',payrolls.name) as name",
      'payrolls.name as payroll',
      'payrolls.code',
      'currencies.name as currency',
      'countries.id as countryId',
      'frequencies.name as frequency',
      'companies.name as company',
      'companies.id as companyId'
    ],
    join: [
      'INNER JOIN currencies ON payrolls.currency_id = currencies.id',
      'INNER JOIN companies ON payrolls.company_id = companies.id',
      'INNER JOIN countries ON companies.country_id = countries.id',
      'INNER JOIN frequencies ON frequencies.id = payrolls.frequency_id'
    ],
    where: [
      `payrolls.code IN (${payrolls[0].results
        .map((payroll: any) => `'${payroll.code}'`)
        .join(', ')})`,
      'companies.id = :companyId',
      'payrolls.is_inactive = false'
    ]
  })

  return data[0].results
}

export async function getEmployeesHighLowReport(
  payrollIds: string,
  type: string,
  startDate: string,
  endDate: string
) {
  let where = ''
  if (type && startDate && endDate) {
    switch (type) {
      case 'arrivals':
        where = `employees.joining_date>='${
          startDate ?? ''
        }' AND employees.joining_date<='${endDate ?? ''}'`
        break
      case 'dismissals':
        where = `employees.leave_date>='${
          startDate ?? ''
        }' AND employees.leave_date<='${endDate ?? ''}'`
        break
      case 'all':
        where = `(employees.leave_date>='${
          startDate ?? ''
        }' AND employees.leave_date<='${
          endDate ?? ''
        }' OR employees.joining_date>='${
          startDate ?? ''
        }' AND employees.joining_date<='${endDate ?? ''}')`

        break
      default:
        break
    }
  }

  return getEmployeesReport(payrollIds, where)
}

export async function getEmployeesStandardVacation(
  payrollIds: string,
  terminatedEmployees: boolean
) {
  let where = ''
  if (!terminatedEmployees) {
    where = `employees.leave_date is null`
  }

  const employees = await getEmployeesReport(payrollIds, where)
  return employees.map((employee: any) => {
    return {
      ...employee,
      name: `${employee.name} ${employee.fechaSalida ? '(CESADO)' : ''}`
    }
  })
}

export async function getEmployeesVacationsAccrual(payrollIds: string) {
  const employees = await getEmployeesReport(payrollIds, '')
  return employees.map((employee: any) => {
    return {
      ...employee,
      name: employee.name
    }
  })
}

export async function getEmployeesFamilyData(
  payrollIds: string,
  status: string[]
) {
  let where = ''
  if (status && status.length === 1) {
    switch (status[0]) {
      case 'active':
        where = 'employees.leave_date is null'
        break
      case 'inactive':
        where = 'employees.leave_date is not null'
        break
      default:
        break
    }
  }
  return getEmployeesReport(payrollIds, where)
}

export async function getEmployeesStandardEmployees(
  payrollIds: string,
  terminatedEmployees: boolean
) {
  let where = ''
  if (terminatedEmployees) {
    where = `employees.leave_date is null`
  }

  return getEmployeesReport(payrollIds, where)
}

export async function getEmployeesVacationBalance(
  payrollIds: string,
  terminatedEmployees: boolean
) {
  let where = ''
  if (!terminatedEmployees) {
    where = `employees.leave_date is null`
  }

  return getEmployeesReport(payrollIds, where)
}

export async function getEmployeesLiensLoans(
  payrollIds: string,
  startDate: string,
  endDate: string
) {
  const response = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: ['processed_payrolls.employees'],
    join: [
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id',
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id'
    ],
    where: [
      `processed_payrolls.payroll_id IN (${payrollIds})`,
      `processed_payrolls.start_date>='${startDate}' AND processed_payrolls.end_date<='${endDate}'`,
      "processes.code = 'N'",
      "payroll_status.code = 'CLOSED'"
    ]
  })
  return response[0].results
}

export async function getEmployeesEmbargoes(payrollIds: string) {
  const response = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: ['processed_payrolls.employees'],
    join: [
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id',
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id'
    ],
    where: [
      `processed_payrolls.payroll_id IN (${payrollIds})`,
      `processed_payrolls.end_date = (
        SELECT MAX(sub.end_date)
        FROM processed_payrolls sub
        WHERE sub.payroll_id = processed_payrolls.payroll_id 
        and sub.process_id = processed_payrolls.process_id
        and sub.payroll_status_id = processed_payrolls.payroll_status_id
      )`,
      "processes.code = 'N'",
      "payroll_status.code = 'CLOSED'"
    ]
  })
  return response[0].results
}

export async function getEmployeesReport(
  payrollIds: string,
  conditions: string,
  employeesIds: string = ''
) {
  const where = ['employees.is_deleted=false']
  if (payrollIds !== '') where.push(`employees.payroll_id in (${payrollIds})`)
  if (employeesIds !== '') where.push(`employees.id in (${employeesIds})`)
  if (conditions !== '') where.push(conditions)

  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      'false as isChecked'
    ],
    join: [
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: ['order by employees.name asc']
  })

  return data[0].results
}

export async function getEmployeesReportByRecordId(
  employeesIds: string,
  employerRecordId: string
) {
  const where = ['employees.is_deleted=false']
  if (employeesIds !== '') where.push(`employees.id in (${employeesIds})`)
  if (employerRecordId !== '')
    where.push(`employees.employer_record_id = '${employerRecordId}'`)

  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      'false as isChecked'
    ],
    join: [
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: ['order by employees.name asc']
  })

  return data[0].results
}

export async function getGovernmentEmployees(
  payrollIds: string,
  startDate: string,
  endDate: string,
  types?: string[]
) {
  const where = [
    `government_news.payroll_id IN (${payrollIds})`,
    `government_news.date >= '${startDate}' AND government_news.date <= '${endDate}'`,
    'government_news.is_deleted = false'
  ]

  if (types && types.length > 0) {
    where.push(
      `government_new_types.code IN (${types
        .map(type => `'${type}'`)
        .join(',')})`
    )
  }

  const data = await getData<any>({
    tables: ['pg_government_news'],
    fields: [`government_news.employee->>'id' as id`],
    join:
      types && types.length > 0
        ? [
            'INNER JOIN government_new_types ON government_news.government_new_type_id = government_new_types.id'
          ]
        : undefined,
    where
  })

  let _employees: any = data[0].results.map((item: any) => item.id)

  return reduceEmployees(_employees)
}

export async function getConcepts(
  payrollIds?: string,
  report?: string,
  categoriesIds?: string,
  processesCodes?: string
) {
  const fields = []
  const where = ['concepts.is_deleted = false']
  const join = []

  switch (report) {
    case 'customizedPayroll':
    case 'asoveritas':
    case 'bankLafise':
    case 'irpf':
      fields.push('concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN master_concepts ON concepts.master_concept_id=master_concepts.id'
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'historical':
    case 'ISRHonduras':
    case 'conceptBases':
      fields.push('concepts.id', 'concepts.code')
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'nets':
      fields.push(
        'concepts.id',
        'concepts.code',
        'master_concepts.code as master_code'
      )
      join.push(
        'INNER JOIN LATERAL jsonb_array_elements_text(concepts.processes) p(process) ON TRUE',
        `INNER JOIN processes ON processes.id = p.process::uuid AND  processes.code IN (${processesCodes})`,
        'INNER JOIN master_concepts ON concepts.master_concept_id=master_concepts.id'
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'incidents':
    case 'lafise':
    case 'promerica':
    case 'bonus':
    case 'magisterio':
      fields.push('concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN LATERAL jsonb_array_elements_text(concepts.processes) p(process) ON TRUE',
        `INNER JOIN processes ON processes.id = p.process::uuid AND  processes.code IN (${processesCodes})`
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'payrollStandard':
    case 'conceptDetails':
    case 'summaryConcept':
      fields.push('concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN master_concepts ON concepts.master_concept_id=master_concepts.id',
        'INNER JOIN concept_categories ON master_concepts.concept_category_id=concept_categories.id'
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      where.push(`concept_categories.id IN (${categoriesIds})`)
      break
    case 'vacation':
      fields.push('distinct concepts.code as id')
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'bacSanJoseFormato06HN':
    case 'santarderBankUY':
    case 'bancomer-232':
    case 'banamex-d':
    case 'banamex-paylink-484':
      fields.push('concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN LATERAL jsonb_array_elements_text(concepts.processes) p(process) ON TRUE',
        `INNER JOIN processes ON processes.id = p.process::uuid AND  processes.code IN (${processesCodes})`
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'PrevisionSocialBank':
    case 'CCSS':
    case 'INS':
    case 'SUAAffiliations':
    case 'nationalBankCostaRica':
    case 'bacFormato11':
    case 'bacFormato17':
    case 'bacSanJoseFormato06':
    case 'bancoProgreso':
    case 'daviviendaCR':
    case 'costaRicaBankBcr':
    case 'generalBankCR':
    case 'scotibank':
    case 'lci':
    case 'pagus':
    case 'rap':
    case 'vacationMSC':
    case 'vacationsAccrual':
    case 'bacSba':
    case 'citibankCR':
    case 'citibankUY':
    case 'citibankHN':
      fields.push('DISTINCT concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN LATERAL jsonb_array_elements_text(concepts.processes) p(process) ON TRUE',
        `INNER JOIN processes ON processes.id = p.process::uuid AND processes.code IN (${processesCodes})`
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    case 'AllowancesAndDeductions':
      fields.push('concepts.id', 'concepts.code')
      join.push(
        'INNER JOIN master_concepts ON concepts.master_concept_id = master_concepts.id',
        'INNER JOIN concept_categories ON master_concepts.concept_category_id = concept_categories.id',
        'INNER JOIN concept_types ON master_concepts.concept_type_id = concept_types.id'
      )
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      where.push(`concept_categories.code IN ('payroll')`)
      where.push(`concept_types.code IN ('deduction', 'assignment')`)
      break
    case 'SUAWorkers':
    case 'SUAMovements':
    case 'IDSEJoining':
    case 'IDSESalaries':
    case 'rentTemplate':
      fields.push('DISTINCT concepts.id', 'concepts.code')
      where.push(`concepts.payroll_id IN (${payrollIds})`)
      break
    default:
      break
  }

  fields.push("CONCAT(concepts.code,' - ',concepts.name) as name")
  const data = await getData<any>({
    tables: ['pg_concepts'],
    fields,
    where: where,
    join,
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getProcessCountry(): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_processes'],
    fields: ['processes.code as id', 'processes.name'],
    join: [
      'INNER JOIN LATERAL jsonb_array_elements_text(processes.countries) c(country) ON TRUE',
      'INNER JOIN countries ON countries.id = c.country::uuid'
    ],
    where: ['processes.is_deleted = false', 'countries.id in (:countryId)']
  })

  return response[0].results
}

export async function getConceptCategories(): Promise<any> {
  const response = await getData<any>({
    tables: ['pg_concept_categories'],
    fields: ['id', 'name', 'code'],
    modifier: ['order by name asc']
  })

  return response[0].results
}

export async function getProcessedPayrolls(
  payrollIds: string,
  processesIds: string,
  startDate: string,
  endDate: string,
  status: string
) {
  const where = [
    `processed_payrolls.payroll_id IN (${payrollIds})`,
    `processed_payrolls.start_date>='${startDate}' AND processed_payrolls.end_date<='${endDate}'`,
    `payroll_status.code='${status}'`
  ]
  if (processesIds !== '') where.push(`processes.code IN (${processesIds})`)
  const data = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      'processed_payrolls.payroll_id',
      'processes.code as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      'processed_payrolls.employees'
    ],
    join: [
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id',
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where,
    modifier: ['order by processed_payrolls.created_at desc']
  })

  return data[0].results
}

export async function getProcessedPayrollsVariability(
  payrollIds: string,
  startDate: string,
  endDate: string,
  status: string
) {
  const where = [
    `processed_payrolls.payroll_id IN (${payrollIds})`,
    `processed_payrolls.start_date>='${startDate}' AND processed_payrolls.end_date<='${endDate}'`,
    `payroll_status.code='${status}'`
  ]
  where.push(`processes.name = 'RPT-VARIABILIDAD'`)
  const data = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      'processed_payrolls.payroll_id',
      'processes.name as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      'processed_payrolls.employees'
    ],
    join: [
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id',
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where,
    modifier: ['order by processed_payrolls.created_at desc']
  })

  return data[0].results
}

export async function getProcessedPayrollsComparative(
  payrollIds: string,
  processesCode: string,
  date: string,
  isClose: boolean
) {
  const where = [
    `processed_payrolls.payroll_id IN (${payrollIds})`,
    `processed_payrolls.end_date='${date}'`,
    `processes.code ='${processesCode}'`
  ]
  isClose
    ? where.push("payroll_status.code='CLOSED'")
    : where.push("payroll_status.code='PRENOMINA'")
  const data = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      'processed_payrolls.payroll_id',
      'processes.code as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      'processed_payrolls.employees'
    ],
    join: [
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id',
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where,
    modifier: ['order by processed_payrolls.created_at desc']
  })

  return data[0].results
}

export async function getBanks() {
  const data = await getData<any>({
    tables: ['pg_banks'],
    fields: ['id', 'name'],
    where: [
      'is_inactive = false',
      'is_deleted = false',
      'country_id=:countryId'
    ],
    modifier: ['order by name asc']
  })
  return data[0].results
}

export async function getCurrencies(ids: any = '') {
  const where = ['is_deleted = false']
  if (ids !== '') where.push(`id IN (${ids})`)
  const data = await getData<any>({
    tables: ['pg_currencies'],
    fields: ['id', "CONCAT(code,' - ',name) as name", 'code'],
    where,
    modifier: ['order by code asc']
  })

  return data[0].results
}

export async function getPaymentTypes() {
  const data = await getData<any>({
    tables: ['pg_salary_payment_types'],
    fields: ['id', 'name'],
    where: ['is_deleted = false'],
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getPaymentBases() {
  const data = await getData<any>({
    tables: ['pg_payment_bases'],
    fields: ['id', 'name'],
    where: ['is_deleted = false', 'country_id=:countryId'],
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getPaymentBasesWithoutCountry() {
  const data = await getData<any>({
    tables: ['pg_payment_bases'],
    fields: ['id', 'name', 'code'],
    where: ['is_deleted = false'],
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getDepartments(companyIds: string) {
  const data = await getData<any>({
    tables: ['pg_directions'],
    fields: [
      'departments.id',
      "CONCAT(departments.code,' - ',departments.name) as name",
      'departments.code'
    ],
    where: [
      'departments.is_deleted = false',
      `directions.company_id IN ('${companyIds}')`
    ],
    join: [
      'INNER JOIN managements ON directions.id = managements.direction_id',
      'INNER JOIN departments ON managements.id = departments.management_id'
    ],
    modifier: ['order by departments.code asc']
  })

  return data[0].results
}

export async function getIncreaseReasons() {
  const data = await getData<any>({
    tables: ['pg_increase_reasons'],
    fields: ['id', "CONCAT(code,' - ',name) as name", 'code'],
    where: ['is_deleted = false', 'country_id = :countryId'],
    modifier: ['order by code asc']
  })

  return data[0].results
}

export async function getCurrenciesLafise(reportCode: string) {
  const data = await getData<any>({
    tables: ['pg_reports_config'],
    fields: ['currencies'],
    where: [`code = '${reportCode}'`],
    modifier: ['order by code asc']
  })

  return data[0].results[0].currencies
}

export async function getBankParentId(reportCode: string) {
  const data = await getData<any>({
    tables: ['pg_reports_config'],
    fields: ['bank_id as bank'],
    where: [`code = '${reportCode}'`]
  })

  return data[0].results[0].bank
}

export async function getBaseSalaries() {
  const data = await getData<any>({
    tables: ['pg_base_salaries'],
    fields: ['id', "CONCAT(code,' - ',name) as name", 'code'],
    where: ['is_deleted = false'],
    modifier: ['order by code asc']
  })

  return data[0].results
}

export async function getCompaniesAccounting() {
  const data = await getData<any>({
    tables: ['pg_companies'],
    fields: ['integrations'],
    where: ['id = :companyId'],
    modifier: ['order by id asc']
  })

  return data[0].results[0].integrations.NETSUITE_ACCOUNTING
}

/* Consulta para vista de reportes */
export async function getTypesReport(
  internalReports: boolean = false
): Promise<any> {
  const where = [
    "(companies.id in (:companyId) OR reports_config.companies IS NULL OR reports_config.companies = '[]'::jsonb)",
    "(countries.id in (:countryId) OR reports_config.countries IS NULL OR reports_config.countries = '[]'::jsonb)",
    "report_types.code<>'certificates-and-letters'"
  ]
  if (internalReports) where.push(`report_types.name = 'Reportes internos'`)
  else where.push(`report_types.name <> 'Reportes internos'`)
  const response: any = await getData({
    tables: ['pg_reports_config'],
    fields: [
      'report_types.id',
      'report_types.name as nameType',
      'reports_config.name',
      'reports_config.icon',
      'reports_config.path',
      'reports_config.code'
    ],
    join: [
      'INNER JOIN report_types ON reports_config.report_type_id=report_types.id',
      'LEFT JOIN LATERAL jsonb_array_elements_text(reports_config.companies) c(company) ON TRUE',
      'LEFT JOIN companies ON companies.id = c.company::uuid',
      'LEFT JOIN LATERAL jsonb_array_elements_text(reports_config.countries) t(country) ON TRUE',
      'LEFT JOIN countries ON countries.id = t.country::uuid'
    ],
    modifier: [
      'order by report_types.name, reports_config.icon, reports_config.name asc'
    ],
    where,
    options: {
      outputFormat: 'json'
    }
  })

  const arr: any = []
  let arr2: any = []

  response[0].results.reduce((res: any, value: any) => {
    if (!res[value.nameType]) {
      arr2 = []
      res[value.nameType] = {
        name: value.nameType,
        items: arr2
      }
      arr.push(res[value.nameType])
    }
    arr2.push(value)
    return res
  }, {})

  return arr
}

export async function getExternalReports(bankReportId: string): Promise<any> {
  let httpExternal = new HttpService()
  const userStore = useUserStore()
  let authorization = await userStore.getValidToken()

  let opts = {
    headers: {
      Authorization: authorization,
      'x-country-id': usePayrollStore().payroll?.country.iso_code,
      'x-company-id': usePayrollStore().payroll?.company.id,
      'x-channel': 'APS-WEB',
      'user-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  }

  let response: any = await httpExternal.getWithHeaders(
    'external-reports/externos/reports',
    opts
  )

  const arr = response.data.map((report: any) => ({
    ...report,
    id: bankReportId,
    code: 'externals/' + report.reportId + '/' + report.name,
    nameType: 'Entidades Bancarias',
    icon: 'txt',
    path: '/reports/external/'
  }))

  return arr
}

export async function getSucursals() {
  const data = await getData<any>({
    tables: ['pg_sucursals'],
    fields: ['id', 'name'],
    where: ['is_deleted = false', 'company_id=:companyId'],
    modifier: ['order by name asc']
  })

  return data[0].results
}
/* Consultar solicitud de reporte */
export async function getReportRequest(id: string) {
  const data = await getData<any>({
    tables: ['pg_reports_requests'],
    fields: [
      'reports_requests.errors',
      'process_status.name as status',
      'reports_requests.url'
    ],
    join: [
      'INNER JOIN process_status ON reports_requests.status_id=process_status.id'
    ],
    where: [`reports_requests.id ='${id}'`]
  })

  return data[0].results[0]
}

/* Consultar solicitud de asiento contable */
export async function getAccountingEntryNTRequest(id: string) {
  const data = await getData<any>({
    tables: ['pg_accounting_entries_requests'],
    fields: ['*'],
    where: [`id ='${id}'`]
  })

  return data[0].results[0]
}

/* Reportes */
export async function generateHighLow(data: ReportHighLow): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      type: data.parameters.type,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      translate: data.parameters.translate,
      format: data.parameters.format,
      orderBy: data.parameters.orderBy,
      additionalColumns: data.parameters.additionalColumns
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateStandardVacation(
  data: ReportStandardVacation
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      conceptCode: data.parameters.conceptCode,
      endDate: data.parameters.endDate,
      additionalColumns: data.parameters.additionalColumns
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateVacationsAccrual(
  data: ReportVacationsAccrual
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateFamilyData(
  data: ReportFamilyData
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      employeeStatuses: data.parameters.employeeStatuses,
      additionalColumns: data.parameters.additionalColumns,
      format: data.parameters.format,
      orderBy: data.parameters.orderBy
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateHistorical(
  data: ReportHistorical
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      orderBy: data.parameters.orderBy,
      allowDifferentOrigin: data.parameters.allowDifferentOrigin,
      additionalColumns: data.parameters.additionalColumns
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateIncomeTax(
  data: ReportIncomeTax
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      baseRetention: data.parameters.baseRetention,
      incomeTax: data.parameters.incomeTax,
      pensionDeduction: data.parameters.pensionDeduction,
      filterByEmployeesWithIncomeTax:
        data.parameters.filterByEmployeesWithIncomeTax,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateStandardEmployees(
  data: ReportStandardEmployees
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      orderBy: data.parameters.orderBy,
      excludeDismissed: data.parameters.excludeDismissed,
      additionalColumns: data.parameters.additionalColumns,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateEmployeeBankAccounts(
  data: ReportEmployeeBankAccounts
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      orderBy: data.parameters.orderBy,
      excludeDismissed: data.parameters.excludeDismissed,
      banks: data.parameters.banks,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateHeadcountRegional(
  data: ReportHeadcountRegional
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      orderBy: data.parameters.orderBy,
      excludeDismissed: data.parameters.excludeDismissed,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateVacationBalance(
  data: ReportVacationBalance
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      format: data.parameters.format,
      additionalColumns: data.parameters.additionalColumns,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePayrollStandard(
  data: ReportPayrollStandard
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateCustomizedPayroll(
  data: ReportCustomizedPayroll
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      concepts: data.parameters.concepts,
      columns: data.parameters.columns,
      showQuantity: data.parameters.showQuantity,
      showAmount: data.parameters.showAmount,
      showCodes: data.parameters.showCodes,
      showHeader: data.parameters.showHeader,
      employees: data.parameters.employees,
      currencyId: data.parameters.currencyId,
      processedPayroll: data.parameters.processedPayroll
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateVariability(
  data: ReportVariability
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      status: data.parameters.status,
      year: Number(data.parameters.year),
      employees: data.parameters.employees,
      bimester: Number(data.parameters.bimester)
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateIncidents(
  data: ReportIncidents
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateComparative(
  data: ReportComparative
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startPeriod: data.parameters.startPeriod,
      endPeriod: data.parameters.endPeriod,
      categories: data.parameters.categories,
      employees: data.parameters.employees,
      translate: data.parameters.translate,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateComparativeConcept(
  data: ReportComparativeConcept
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startPeriod: data.parameters.startPeriod,
      endPeriod: data.parameters.endPeriod,
      categories: data.parameters.categories,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateNet(data: ReportNet): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      banks: data.parameters.banks,
      currencies: data.parameters.currencies,
      salaryPaymentTypes: data.parameters.salaryPaymentTypes,
      paymentBases: data.parameters.paymentBases,
      paymentDate: data.parameters.paymentDate,
      orderBy: data.parameters.orderBy,
      showCodes: data.parameters.showCodes,
      showSucursals: data.parameters.showSucursals,
      showExchangeRates: data.parameters.showExchangeRates,
      format: data.parameters.format,
      translate: data.parameters.translate,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSummaryPayments(
  data: ReportSummaryPayments
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      banks: data.parameters.banks,
      currencies: data.parameters.currencies,
      salaryPaymentTypes: data.parameters.salaryPaymentTypes,
      paymentBases: data.parameters.paymentBases,
      orderBy: data.parameters.orderBy,
      format: data.parameters.format,
      translate: data.parameters.translate,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSummaryComparative(data: any): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startPeriod: data.parameters.startPeriod,
      endPeriod: data.parameters.endPeriod,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      translate: data.parameters.translate,
      groupByOverallAccumulation: data.parameters.groupByOverallAccumulation
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAnnualAccumulative(data: any): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payroll: data.parameters.payroll,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      status: data.parameters.status,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateConceptDetails(
  data: ReportConceptDetails
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      groupByEmployee: data.parameters.groupByEmployee,
      format: data.parameters.format,
      employees: data.parameters.employees,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSummaryConcepts(
  data: ReportSummaryConcepts
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      groupByOverallAccumulation: data.parameters.groupByOverallAccumulation,
      employees: data.parameters.employees,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateISN(data: ReportISN): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      employees: data.parameters.employees,
      months: data.parameters.months.map(_ => Number(_)),
      year: data.parameters.year,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAllowancesDeductions(
  data: ReportAllowancesDeductions
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateLafise(data: ReportLafise): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      concepts: data.parameters.concepts,
      banks: data.parameters.banks,
      description: data.parameters.description,
      service: data.parameters.service,
      reference: data.parameters.reference,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      identificationFormat: data.parameters.identificationFormat,
      currency: data.parameters.currency
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAccountingProvisions(
  data: ReportAccountingProvisions
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateReportList(data: any): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      query: data.parameters.query,
      fields: data.parameters.fields,
      headers: data.parameters.headers,
      module: data.parameters.module
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAccountingEntry(
  data: ReportAccountingEntry
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      isSummarized: data.parameters.isSummarized,
      hasAuxiliaryFields: data.parameters.hasAuxiliaryFields,
      haveGroupedAccounts: data.parameters.haveGroupedAccounts,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAccountingEntryNT(data: any): Promise<string> {
  const response: any = await http.post('accounting-entries', {
    parameters: {
      payrolls: data.payrolls,
      processes: data.processes,
      startDate: data.startDate,
      endDate: data.endDate,
      isSummarized: data.isSummarized,
      hasAuxiliaryFields: data.hasAuxiliaryFields
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateRequestAccountingEntries(
  data: any,
  id: any
): Promise<string> {
  const response: any = await http.put('accounting-entries/' + id, data)

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSalaryHistoric(
  data: ReportSalaryHistoric
): Promise<string> {
  let object: ReportSalaryHistoric = {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      filters: {
        includeCeasedEmployees: data.parameters.filters.includeCeasedEmployees,
        departmentsId: data.parameters.filters.departmentsId,
        dateOfEmployment: {},
        salaryIncreaseDate: {},
        causeOfSalaryIncreasesId:
          data.parameters.filters.causeOfSalaryIncreasesId,
        baseOfSalariesId: data.parameters.filters.baseOfSalariesId
      }
    }
  }
  if (
    data.parameters.entryDateFrom !== '' ||
    data.parameters.entryDateUntil !== ''
  ) {
    object.parameters.filters.dateOfEmployment = {
      startDate: data.parameters.entryDateFrom,
      endDate: data.parameters.entryDateUntil
    }
  } else {
    delete object.parameters.filters.dateOfEmployment
  }
  if (
    data.parameters.salaryMovementDateFrom !== '' ||
    data.parameters.salaryMovementDateUntil !== ''
  ) {
    object.parameters.filters.salaryIncreaseDate = {
      startDate: data.parameters.salaryMovementDateFrom,
      endDate: data.parameters.salaryMovementDateUntil
    }
  } else {
    delete object.parameters.filters.salaryIncreaseDate
  }

  const response: any = await http.post('reports/', object)

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateAsoveritas(
  data: ReportAsoveritas
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      concepts: data.parameters.concepts,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateG2N(data: ReportG2N): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      categories: data.parameters.categories,
      modifyCode: data.parameters.modifyCode
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePayRegister(
  data: ReportPayRegister
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateMagistery(
  data: ReportMagistery
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateLCI(data: ReportLCI): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generatePagus(data: ReportPagus): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      sucursals: data.parameters.sucursals,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateConceptbases(
  data: ReportConceptBases
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      concepts: data.parameters.concepts
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateBonus(data: ReportBonus): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateVacationMSC(
  data: ReportVacationMSC
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateGTN(data: ReportGTN): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      processes: data.parameters.processes,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      status: data.parameters.status,
      categories: data.parameters.categories,
      showQuantity: data.parameters.showQuantity,
      showAmount: data.parameters.showAmount,
      showCodes: data.parameters.showCodes
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateEmbargoesLoans(
  data: ReportEmbargoesLoans
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      translate: data.parameters.translate
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateEmbargoes(
  data: ReportEmbargoes
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateInfonacotCertification(
  data: ReportInfonacotCertification
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      year: data.parameters.year,
      month: data.parameters.month,
      employerRecordId: data.parameters.employerRecordId,
      workCenterId: data.parameters.workCenterId
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

/**
 * Recorre los procesos que se seleccionaron en la interfaz grafica y envia los parametros al metodo filterPayrollProcess para validar
 * el estado y procesos a los que pertenecen los calculos
 */
export function filterProcessSelectReports(data: any) {
  let _employees: any = []
  let _resultFilter: any = []

  for (let process of data.process) {
    _resultFilter = filterPayrollProcess(
      data.processedPayroll,
      data.payrolls,
      process,
      data.status
    )
    _resultFilter.map((item: any) => {
      _employees = _employees.concat(item?.employees)
    })
  }

  return reduceEmployees(_employees)
}

/**
 * Filtra los calculos de la nomina por nomina y proceso, dependiendo del estado nomina o prenomina y si el proceso es liquidación
 * @param processedPayrolls
 * @param payrollsIds
 * @param process
 * @param status
 * @returns
 */
export function filterPayrollProcess(
  processedPayrolls: any,
  payrollsIds: string[],
  process: string,
  status: string
) {
  let dataProcessedPayrolls: any = []
  for (const payroll of payrollsIds) {
    let _filterPayrollProcess = processedPayrolls.filter(
      (item: any) => item.payroll_id == payroll && item.process == process
    )

    if (_filterPayrollProcess.length > 0) {
      if (status === 'PRENOMINA') {
        if (process == 'L') {
          dataProcessedPayrolls.push(..._filterPayrollProcess)
        } else {
          dataProcessedPayrolls.push(_filterPayrollProcess[0])
        }
      } else {
        dataProcessedPayrolls = dataProcessedPayrolls.concat(
          _filterPayrollProcess
        )
      }
    }
  }

  return dataProcessedPayrolls
}

export function reduceEmployees(employees: Array<[]>) {
  let uniqueEmployees: any = []
  employees.reduce((res: any, value: any) => {
    if (!res[value]) {
      res[value] = value
      uniqueEmployees.push(value)
    }
    return res
  }, {})

  return uniqueEmployees
}

/* Listar años */
export function getListYear(limit: number = 7) {
  let year = dayjs().year()
  year = year + 1
  let countYear
  let itemsYears: any[] = []
  for (let index = 0; index < limit; index++) {
    index === 0 ? (countYear = year) : (countYear = year -= 1)
    itemsYears = itemsYears.concat({
      id: countYear,
      name: countYear
    })
  }

  return itemsYears
}

export async function generateSUAWorkers(
  data: ReportSUAWorkers
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      integratedDailySalaryConcept:
        data.parameters.integratedDailySalaryConcept,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSUAAffiliations(
  data: ReportSUAAffiliations
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSUALicenses(
  data: ReportSUALicenses
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSUALoans(data: ReportSUALoans): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateSUAMovements(
  data: ReportSUAMovements
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      integratedDailySalaryConcept:
        data.parameters.integratedDailySalaryConcept,
      voluntaryContributionConcept:
        data.parameters.voluntaryContributionConcept,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateInfonacotIdentification(
  data: ReportInfonacotIdentification
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      year: data.parameters.year,
      month: data.parameters.month,
      employerRecordId: data.parameters.employerRecordId,
      workCenterId: data.parameters.workCenterId
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateGoSocket4(
  data: ReportGoSocket4
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      processedPayrollId: data.parameters.processedPayrollId,
      employees: data.parameters.employees,
      serialNumber: data.parameters.serialNumber,
      folioNumber: data.parameters.folioNumber,
      datePayment: data.parameters.paymentDate,
      regymeTypeCode: data.parameters.regymeType,
      paymentFrequencyCode: data.parameters.paymentFrequency,
      otherDocuments: data.parameters?.otherDocuments || []
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function stampedPayrolls(
  data: ParameterStampedPayroll
): Promise<string> {
  const response: any = await http.post('calculation/close/stamped/', {    
    closedPayrollId: data.closedPayrollId,
    stampedDate: data.stampedDate  
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
} 

export async function generateInfonacotCredit(
  data: ReportInfonacotCredit
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      year: data.parameters.year,
      month: data.parameters.month,
      employerRecordId: data.parameters.employerRecordId,
      workCenterId: data.parameters.workCenterId
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateRentTemplate(
  data: ReportRentTemplate
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employees: data.parameters.employees,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      salaryAmountConcepts: data.parameters.salaryAmountConcepts,
      supplementaryPensionsConcepts:
        data.parameters.supplementaryPensionsConcepts,
      withheldTaxSLConcepts: data.parameters.withheldTaxSLConcepts,
      relativeCreditSLConcepts: data.parameters.relativeCreditSLConcepts,
      salaryAmountConceptsOthersEmployers: data.parameters.salaryAmountConceptsOthersEmployers,
      retentionBaseDGPConcepts: data.parameters.retentionBaseDGPConcepts,
      withheldTaxDGPConcepts: data.parameters.withheldTaxDGPConcepts,
      retentionBaseOISEConcepts: data.parameters.retentionBaseOISEConcepts,
      withheldTaxOISEConcepts: data.parameters.withheldTaxOISEConcepts,
      retentionBaseJPConcepts: data.parameters.retentionBaseJPConcepts,
      withheldTaxJPConcepts: data.parameters.withheldTaxJPConcepts
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function getClosedPayrolls(
  payrollId: string[],
  processesCode: string,
  startDate: string,
  endDate: string
) {
  const where = [
    `processed_payrolls.payroll_id IN ('${payrollId.map(p => p).join("','")}')`,
    `processed_payrolls.start_date>='${startDate}' AND processed_payrolls.end_date<='${endDate}'`,
    `payroll_status.code='CLOSED'`,
    `processes.code='${processesCode}'`
  ]
  const data = await getData<any>({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      'processed_payrolls.payroll_id',
      'processes.code as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      'processed_payrolls.employees',
      "CONCAT(payrolls.code,': ',TO_CHAR(processed_payrolls.start_date,'dd-mm-yyyy'),' - ',TO_CHAR(processed_payrolls.end_date,'dd-mm-yyyy')) as name"
    ],
    join: [
      'INNER JOIN payroll_status ON processed_payrolls.payroll_status_id = payroll_status.id',
      'INNER JOIN processes ON processed_payrolls.process_id = processes.id',
      'INNER JOIN payrolls ON processed_payrolls.payroll_id = payrolls.id'
    ],
    where,
    modifier: ['order by payrolls.code ASC, processed_payrolls.end_date DESC']
  })

  return data[0].results
}

export async function getStampedPayrolls(
  processedPayrollId: string
) {
  const where = [
    `closed_payrolls.is_deleted=false`,
    `closed_payrolls.processed_payroll_id = '${processedPayrollId}'`
  ]
  const data = await getData<any>({
    tables: ['pg_closed_payrolls'],
    fields: [
      'stamped_payrolls.id',
      'stamped_payrolls.stamped_date',
      'stamped_payrolls.stamped_by',
      'stamped_payrolls.is_deleted',
      'closed_payrolls.id as closed_payroll_id'
    ],
    join: [
      'LEFT JOIN stamped_payrolls ON stamped_payrolls.closed_payroll_id = closed_payrolls.id'
    ],
    where
  })

  return data[0].results || []
}

export async function getEmployees(
  payrollId: string,
  conditions: string,
  employeesIds: string = ''
) {
  const where = ['employees.is_deleted=false']
  if (payrollId !== '') where.push(`employees.payroll_id in ('${payrollId}')`)
  if (employeesIds !== '') where.push(`employees.id in (${employeesIds})`)
  if (conditions !== '') where.push(conditions)

  const data = await getData<any>({
    tables: ['pg_employees'],
    fields: [
      'distinct employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      "CONCAT(payrolls.code,': ',employees.code) as codigo",
      'joining_reasons.name as causaIngreso',
      "CONCAT(payrolls.code,': ',employees.code,' - ',employees.name) as codigo_name",
      'false as isChecked',
      "CONCAT(employer_records.code,' - ',custom_options.name) as registroPatronal"
    ],
    join: [
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id',
      'INNER JOIN payrolls ON employees.payroll_id = payrolls.id',
      'LEFT JOIN employer_records ON employees.employer_record_id = employer_records.id',
      "LEFT JOIN custom_options ON json_extract_path_text(employer_records.custom_fields::json, 'custom:mxRiskClass')::uuid = custom_options.id"
    ],
    where,
    modifier: ['order by employees.name asc']
  })

  return data[0].results
}

export async function generateIDSEJoining(
  data: ReportIDSEJoining
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      integratedDailySalaryConcept:
        data.parameters.integratedDailySalaryConcept,
      guide: data.parameters.guide,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateIDSELeaving(
  data: ReportIDSELeaving
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      guide: data.parameters.guide,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function generateIDSESalaries(
  data: ReportIDSESalaries
): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      employerRecordId: data.parameters.employerRecordId,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      employees: data.parameters.employees,
      integratedDailySalaryConcept:
        data.parameters.integratedDailySalaryConcept,
      guide: data.parameters.guide,
      format: data.parameters.format
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}



export function exportExcel(colums: {key: string, title:string, type:string}[], rows: any[]) {
  const exportColumns = colums

  const dataForSheet = rows.map(r => ({
    ...exportColumns.reduce((obj, col) => {
      if(col.type === 'array')
        obj[col.title] = r[col.key]?.join(', ') || ''
      else
        obj[col.title] = r[col.key]

      return obj
    }, {} as any)
  }))

  const ws = XLSX.utils.json_to_sheet(dataForSheet)

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, "shhet1")

  XLSX.writeFile(wb, "Retimbrado.xlsx")
}
